import SpendingDemandListPresenter from "./SpendingDemandListPresenter"
import { SpendingDemandListPresenterV2 } from "./SpendingDemandListPresenterV2"




const SpendingDemandList = SpendingDemandListPresenter

export default SpendingDemandList
export { SpendingDemandListPresenterV2 }